import { openVqqRequestMessages } from "../utils/vqqOpenRequests";

/**
 * Shown under a template picker when the vendor already has an open VQQ request for one or
 * more of the picked templates (US 14958). Renders nothing when there is no clash.
 */
export default function OpenVqqRequestNotice({ vendorName, conflicts, className = "" }) {
  const lines = openVqqRequestMessages(vendorName, conflicts);
  if (lines.length === 0) return null;
  return (
    <div role="alert" data-testid="open-vqq-request-notice" className={`space-y-1 ${className}`}>
      {lines.map((line) => (
        <p key={line} className="text-red-500 text-sm">
          {line}
        </p>
      ))}
    </div>
  );
}
